/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { Button } from 'antd';
import { DateTime } from 'luxon';
import { useCallback, useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { useQuery } from 'react-query';
import { useParams } from 'react-router-dom';

import { obituaryService } from 'config/services';

import { HttpError } from 'helpers/http';

import { Obituary } from 'types/services/obituary';

import { Footer } from './Footer';
import { Header } from './Header';

export const FrontViewInvoice = () => {
  const { id } = useParams<{ id?: string }>();
  const [formattedString, setFormattedString] = useState('');
  const [formattedStringBereaved, setFormattedStringBereaved] = useState('');
  const {
    isLoading,
    data: obituary,
    refetch,
  } = useQuery<Obituary, HttpError>(['getObituary', id], () => obituaryService.getObituaryById(parseInt(id || '')), {
    enabled: typeof id !== 'undefined',
  });

  const [message, setMessage] = useState('');

  useEffect(() => {
    const regex = /(<([^>]+)>)/gi;
    if (obituary && obituary.main_text && obituary.main_text.match(regex)) {
      setFormattedString(obituary.main_text.replace(regex, ' ').replace(new RegExp('\r?\n', 'g'), '<br />'));
    }
    if (obituary && obituary.bereaved && obituary.bereaved.match(regex)) {
      setFormattedStringBereaved(obituary.bereaved.replace(regex, ' ').replace(new RegExp('\r?\n', 'g'), '<br />'));
    }
  }, [obituary]);

  const useMediaQuery = (width: number) => {
    const [targetReached, setTargetReached] = useState(false);

    const updateTarget = useCallback((e) => {
      if (e.matches) {
        setTargetReached(true);
      } else {
        setTargetReached(false);
      }
    }, []);

    useEffect(() => {
      const media = window.matchMedia(`(max-width: ${width}px)`);
      media.addEventListener('change', updateTarget);
      // Check on mount (callback is not called until a change occurs)
      if (media.matches) {
        setTargetReached(true);
      }

      return () => media.removeEventListener('change', updateTarget);
    }, []);

    return targetReached;
  };

  const isBreakpoint = useMediaQuery(768);

  type ContainerProps = {
    classNames?: string;
    isAvazTv?: boolean;
    width?: string;
    height?: string;
    articleType?: string;
  };

  return (
    <div style={{ display: 'grid', justifyContent: 'center' }} className="printPage">
      <div>
        <p className="c30">
          <span className="c4"></span>
        </p>
        <a id="t.79953a14954e224dea745bd9a972815b9da51e81"> </a>
        <a id="t.1"></a>
        <table className="c16">
          <tr className="c20">
            <td className="c7" colSpan={1} rowSpan={1}>
              <p className="c15">
                <span className="one">
                  <img
                    alt=""
                    src="/image1.png"
                    // eslint-disable-next-line react/style-prop-object
                    className="two"
                    title=""
                  />
                </span>
              </p>
            </td>
          </tr>
          <tr className="c20">
            <td className="c31" colSpan={1} rowSpan={1}>
              <p className="c15">
                <span className="c13">
                  Dru&scaron;tvo za izdava&#269;ku i &scaron;tamparsku djelatnost &rdquo;avaz-roto
                  press&rdquo;d.o.o.Sarajevo, Te&scaron;anjska 24A, 71000 Sarajevo, BiH &bull;{' '}
                </span>
                <span className="c8">Pravna slu&#382;ba:</span>
                <span className="c13">&nbsp;Tel: 033/281-472, Fax: 033/281-382, pravna@avaz.ba &bull; </span>
                <span className="c8">Finansije:</span>
                <span className="c13">
                  &nbsp;Tel: 033/281-382, 281-495,281-492, fax: 033/281-381, a_roto@avaz.ba &bull;{' '}
                </span>
                <span className="c8">Marketing:</span>
                <span className="c13">
                  &nbsp;Tel: 033/281-356, Fax: 033/281-441, marketing@avaz.ba &bull; <br />
                </span>
                <span className="c8">Direktor:</span>
                <span className="c13">&nbsp;Tel: 033/281-391, Fax: 033/471-551; office@avaz.ba &bull; </span>
                <span className="c8">IT:</span>
                <span className="c13">
                  &nbsp;Tel: 033/281-394, it@avaz.ba &bull; <br />
                </span>
                <span className="c8">Plasman i distribucija:</span>
                <span className="c4">
                  &nbsp;Tel: 033/281-364, Fax: 033/281-435, plasman@avaz.ba &bull; ID 4200934630002, PB 01357333,
                  MRB:1-24673 PDV BR : 200934630002
                </span>
              </p>
            </td>
          </tr>
        </table>
        <p className="c21">
          <span className="c4"></span>
        </p>
      </div>

      <p className="c1">
        <span className="c8 c28 c34"></span>
      </p>
      <p className="c1">
        <span className="c4"></span>
      </p>
      <p className="c1">
        <span className="c4"></span>
      </p>
      <p className="c5">
        <span className="c17 c13 c9">FIS D.O.O. VITEZ</span>
      </p>
      <p className="c5">
        <span className="c17 c13">Adresa: Poslovni Centar 96 </span>
      </p>
      <p className="c5">
        <span className="c17 c13">72250, Vitez</span>
      </p>
      <p className="c5">
        <span className="c17 c13">ID : &nbsp;4236020240138</span>
      </p>
      <p className="c5">
        <span className="c13 c17">PDV: 236020240006</span>
      </p>
      <p className="c5">
        <span className="c17 c13 c28">
          &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
          &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
          &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
          &nbsp; &nbsp; &nbsp; &nbsp;Datum izdavanja : 13.01.2023.
        </span>
      </p>

      <p className="c1">
        <span className="c4"></span>
      </p>
      <p className="c1">
        <span className="c4"></span>
      </p>
      <p className="c5">
        <span className="c0 c9">RA&#268;UN BR: 1/23</span>
      </p>

      <p className="c1">
        <span className="c4"></span>
      </p>
      <p className="c1">
        <span className="c4"></span>
      </p>
      <a id="t.a1ca8de273e7785f45622d4f48a28ef3acf6a539"></a>
      <a id="t.0"></a>
      <table className="c16">
        <tr className="c20 c16c20">
          <td className="c3 c33" colSpan={1} rowSpan={1}>
            <p className="c5">
              <span className="c0 c9">Red. &nbsp;br.</span>
            </p>
          </td>
          <td className="c19" colSpan={1} rowSpan={1}>
            <p className="c5">
              <span className="c0 c9">Opis</span>
            </p>
          </td>
          <td className="c32 c33" colSpan={1} rowSpan={1}>
            <p className="c5">
              <span className="c0 c9">Jed. &nbsp;mj.</span>
            </p>
          </td>
          <td className="c24 c33" colSpan={1} rowSpan={1}>
            <p className="c5">
              <span className="c0 c9">Koli&#269;ina &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;u kom</span>
            </p>
          </td>
          <td className="c2 c33" colSpan={1} rowSpan={1}>
            <p className="c5">
              <span className="c0 c9">Cijena bez PDV-a</span>
              <span className="c0">&nbsp;u KM</span>
            </p>
          </td>
          <td className="c25 c33" colSpan={1} rowSpan={1}>
            <p className="c5">
              <span className="c0 c9">PDV 17%</span>
            </p>
          </td>
          <td className="c22" colSpan={1} rowSpan={1}>
            <p className="c5">
              <span className="c0 c9">Iznos sa PDV-om</span>
              <span className="c0">&nbsp;u KM</span>
            </p>
          </td>
        </tr>
        <tr className="c20">
          <td className="c3" colSpan={1} rowSpan={1}>
            <p className="c1">
              <span className="c6"></span>
            </p>
            <p className="c1">
              <span className="c6"></span>
            </p>
            <p className="c5">
              <span className="c0 c9">1.</span>
            </p>
            <p className="c1">
              <span className="c6"></span>
            </p>
            <p className="c1">
              <span className="c6"></span>
            </p>
            <p className="c1">
              <span className="c6"></span>
            </p>
            <p className="c1">
              <span className="c6"></span>
            </p>
            <p className="c1">
              <span className="c6"></span>
            </p>
            <p className="c1">
              <span className="c6"></span>
            </p>
            <p className="c1">
              <span className="c6"></span>
            </p>
          </td>
          <td className="c35" colSpan={1} rowSpan={1}>
            <p className="c1">
              <span className="c6"></span>
            </p>
            <p className="c5">
              <span className="c0">Usluga objave umrlice/sje&#263;anja</span>
            </p>
          </td>
          <td className="c32" colSpan={1} rowSpan={1}>
            <p className="c1">
              <span className="c6"></span>
            </p>
            <p className="c5">
              <span className="c0">kom</span>
            </p>
          </td>
          <td className="c24" colSpan={1} rowSpan={1}>
            <p className="c15 c36">
              <span className="c6"></span>
            </p>
            <p className="c15">
              <span className="c0">1</span>
            </p>
          </td>
          <td className="c2" colSpan={1} rowSpan={1}>
            <p className="c10">
              <span className="c6"></span>
            </p>
            <p className="c11">
              <span className="c0">10,00</span>
            </p>
          </td>
          <td className="c25" colSpan={1} rowSpan={1}>
            <p className="c10">
              <span className="c6"></span>
            </p>
            <p className="c11">
              <span className="c0">1,70</span>
            </p>
          </td>
          <td className="c23" colSpan={1} rowSpan={1}>
            <p className="c10">
              <span className="c6"></span>
            </p>
            <p className="c15">
              <span className="c0">&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; 11,70</span>
            </p>
          </td>
        </tr>
        <tr className="c20">
          <td className="c3" colSpan={1} rowSpan={1}>
            <p className="c1">
              <span className="c6"></span>
            </p>
          </td>
          <td className="c35" colSpan={1} rowSpan={1}>
            <p className="c5">
              <span className="c0 c9">UKUPNO SA PDV-om:</span>
            </p>
          </td>
          <td className="c32" colSpan={1} rowSpan={1}>
            <p className="c1">
              <span className="c6"></span>
            </p>
          </td>
          <td className="c24" colSpan={1} rowSpan={1}>
            <p className="c1">
              <span className="c6"></span>
            </p>
          </td>
          <td className="c2" colSpan={1} rowSpan={1}>
            <p className="c11">
              <span className="c0 c9">10,00</span>
            </p>
          </td>
          <td className="c25" colSpan={1} rowSpan={1}>
            <p className="c11">
              <span className="c0 c9">1,70</span>
            </p>
          </td>
          <td className="c23" colSpan={1} rowSpan={1}>
            <p className="c11">
              <span className="c0 c9">11,70</span>
            </p>
          </td>
        </tr>
      </table>

      <p className="c1">
        <span className="c4"></span>
      </p>
      <p className="c1">
        <span className="c4"></span>
      </p>
      <p className="c1">
        <span className="c4"></span>
      </p>
      <p className="c1">
        <span className="c4"></span>
      </p>
      <p className="c1">
        <span className="c4"></span>
      </p>
      <p className="c1">
        <span className="c13 c14"></span>
      </p>
      <p className="c5">
        <span className="c13 c26">
          &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Fakturisao : &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
          &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
          &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
          &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
          &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Direktor :
        </span>
      </p>

      <p className="c1">
        <span className="c4"></span>
      </p>
      <p className="c1">
        <span className="c4"></span>
      </p>
      <p className="c1">
        <span className="c4"></span>
      </p>
      <p className="c1">
        <span className="c4"></span>
      </p>
      <p className="c1">
        <span className="c4"></span>
      </p>
      <div>
        <p className="c30">
          <span className="c4"></span>
        </p>
        <a id="t.e2ce03268b3835e24a701a85e332829efb79a630"></a>
        <a id="t.2"></a>
        <table className="c16">
          <tr className="c20">
            <td className="c12" colSpan={1} rowSpan={1}>
              <p className="c15">
                <span className="three">
                  <img alt="" src="/image2.jpg" className="four" title="" />
                </span>
              </p>
            </td>
            <td className="c29" colSpan={1} rowSpan={1}>
              <p className="c15">
                <span className="c13 c9">UniCredit Bank d.d. Sarajevo:</span>
                <span className="c4">&nbsp;3383202266402293;</span>
              </p>
              <p className="c15">
                <span className="c4">
                  &nbsp;Devizni ra&#269;un: IBAN: BA39 &nbsp;3383204893244355 - broj partije: 20008844101; SWIFT CODE:
                  UNCRBA22XXX
                </span>
              </p>
              <p className="c15">
                <span className="c13">&nbsp;&bull; </span>
                <span className="c13 c9">Sparkasse bank d.d.</span>
                <span className="c4">
                  &nbsp;TRN: 1990000000142322; &nbsp;SWIFT CODE: ABSBBA22; IBAN: BA39 1990000000142322
                </span>
              </p>
              <p className="c15">
                <span className="c13 c9">Nova banka a.d Banja Luka TRN:</span>
                <span className="c13">
                  &nbsp;5556000020469822
                  <br />
                  Raiffeisen bank d.d{' '}
                </span>
                <span className="c13 c9">TRN</span>
                <span className="c4">
                  : 1610000193540134; Devizni racun: SWIFT CODE: RZBABA2S; IBAN: BA39 1611000004049905
                </span>
              </p>
            </td>
          </tr>
        </table>
        <p className="c15 c36">
          <span className="c4"></span>
        </p>
      </div>
    </div>
  );
};
